import { useState, useMemo } from "react";

type AthleteRef = { id: string; name: string };

type Props = {
  athletes: AthleteRef[];
  selected: string[];
  onChange: (ids: string[]) => void;
};

const MultiAthletePicker = ({ athletes, selected, onChange }: Props) => {
  const [q, setQ] = useState("");
  const filtered = useMemo(
    () => athletes.filter((a) => a.name.toLowerCase().includes(q.toLowerCase())),
    [athletes, q],
  );
  const toggle = (id: string) => {
    onChange(selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id]);
  };

  return (
    <div className="rounded-xl bg-muted border border-border p-3 space-y-2">
      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Search athletes…"
        className="w-full px-3 py-2 rounded-lg bg-background border border-border text-sm focus:outline-none focus:ring-2 focus:ring-primary"
      />
      {selected.length > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {selected.map((id) => {
            const a = athletes.find((x) => x.id === id);
            if (!a) return null;
            return (
              <button
                key={id}
                type="button"
                onClick={() => toggle(id)}
                className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-primary text-primary-foreground text-xs font-semibold"
              >
                {a.name} <span aria-hidden>×</span>
              </button>
            );
          })}
        </div>
      )}
      <div className="max-h-48 overflow-y-auto divide-y divide-border">
        {filtered.map((a) => {
          const checked = selected.includes(a.id);
          return (
            <label key={a.id} className="flex items-center gap-2 py-1.5 cursor-pointer text-sm">
              <input
                type="checkbox"
                checked={checked}
                onChange={() => toggle(a.id)}
                className="w-4 h-4 accent-primary"
              />
              <span>{a.name}</span>
            </label>
          );
        })}
        {filtered.length === 0 && (
          <p className="text-xs text-muted-foreground py-2">No athletes match.</p>
        )}
      </div>
    </div>
  );
};

export default MultiAthletePicker;
